<app-header></app-header>
<app-navbar></app-navbar>

<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100 ">
        <!--
        <div class="row mb-3">
            <div class="col-md-6 fw-bold">
                <label for="basic-url" class="form-label color-text"> {{ 'language.langs' | translate }} </label>
            </div>
            <div class="col-md-6 text-end">
                <button type="button" class="btn custombutton" (click)="checkRow()">{{ 'language.newLanguage' |
                    translate }}</button>
            </div>
        </div>-->

        <div class="row">
            <form [formGroup]="validateLaunchForm" (ngSubmit)="onSubmit()" class="needs-validation" novalidate>
                <div class="row">
                    <div class="row">
                        <!-- idpStudent -->
                        <div class="col-auto mb-3">
                            <label for="idpStudent" class="form-label">{{ 'launcher.idp' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="idpStudent" type="text" class="form-control" formControlName="idpStudent"
                                placeholder="IDP user" (input)="validateIdp($event)" [class.is-invalid]="validateLaunchForm.get('idpStudent')?.touched &&
                                                             validateLaunchForm.get('idpStudent')?.invalid"
                                [class.is-valid]="validateLaunchForm.get('idpStudent')?.valid && (validateLaunchForm.get('idpStudent')?.touched)" />
                            @if (validateLaunchForm.get('idpStudent')?.touched &&
                            validateLaunchForm.get('idpStudent')?.invalid )
                            {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                        @let controlDate = validateLaunchForm.get('referenceDate');
                        <!-- date -->
                        <div class="col-auto mb-3">
                            <label for="referenceDate" class="form-label">{{ 'launcher.date' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="referenceDate" type="date" class="form-control" formControlName="referenceDate"
                                [class.is-invalid]="controlDate?.invalid && (controlDate?.touched || formSubmit)"
                                [class.is-valid]="controlDate?.valid && (controlDate?.touched || formSubmit)" />
                            @if (controlDate?.invalid && (controlDate?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                        <!-- iso -->
                        <div class="col-auto mb-3">
                            <fieldset disabled>
                                <label for="isoLanguageCode" class="form-label">{{ 'launcher.iso' | translate }}</label>
                                <input id="isoLanguageCode" type="text" class="form-control" placeholder="ISO"
                                    formControlName="isoLanguageCode" [readonly]="true" />
                            </fieldset>
                        </div>

                        @let control = validateLaunchForm.get('typeRegistrationProcess');
                        <!-- typeRegistrationProcess -->
                        <div class="col-auto mb-3">
                            <label for="typeRegistrationProcess" class="form-label">{{ 'launcher.registration' |
                                translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <select id="typeRegistrationProcess" class="form-select"
                                formControlName="typeRegistrationProcess"
                                [class.is-invalid]="control?.invalid && (control?.touched || formSubmit)"
                                [class.is-valid]="control?.valid && (control?.touched || formSubmit)">
                                @for (typeRegistration of
                                paramLauncherResponseDto.paramLauncherDto.typeRegistrationProcess; track $index) {
                                <option [value]="typeRegistration == 'A' ? 'Alta' : 'Modificacion'">
                                    {{ processTipeKey[typeRegistration] | translate }}
                                </option>
                                }
                            </select>
                            @if (control?.invalid && (control?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                        @let controlTypology = validateLaunchForm.get('typology');
                        <!-- typology -->
                        <div class="col-auto mb-3">
                            <label for="typology" class="form-label">{{ 'launcher.typology' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <select id="typology" class="form-select" formControlName="typology"
                                [class.is-invalid]="controlTypology?.invalid && (controlTypology?.touched || formSubmit)"
                                [class.is-valid]="controlTypology?.valid && (controlTypology?.touched || formSubmit)">
                                @for (typology of paramLauncherResponseDto.paramLauncherDto.typology; track $index) {
                                @if (typology === 'P') {
                                <option [value]="typology"> {{ typology }} - {{ 'launcher.own' | translate }}
                                </option>
                                }
                                <!-- @else {
                                <option [value]="typology"> {{ typology }} - {{ 'launcher.official' | translate }}
                                </option>
                                }-->
                                }
                            </select>
                            @if (controlTypology?.invalid && (controlTypology?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                        @let controlRm = validateLaunchForm.get('rateModelCode');
                        <!-- rateModelCode -->
                        <div class="col-auto mb-3">
                            <label for="rateModelCode" class="form-label">{{ 'launcher.rateModel' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <select id="rateModelCode" class="form-select" formControlName="rateModelCode"
                                [class.is-invalid]="controlRm?.invalid && (controlRm?.touched || formSubmit)"
                                [class.is-valid]="controlRm?.valid && (controlRm?.touched || formSubmit)">
                                @for (rm of this.filteredRateModels; track $index) {
                                <option [value]="rm.idRateModel">{{ rm.idRateModel }} - {{rm.codeRateModel}} -
                                    {{rm.rateModelTraductionDto?.[0]?.shortDescription}}</option>
                                }
                            </select>
                            @if (controlRm?.invalid && (controlRm?.touched || formSubmit)) {
                            <div class="invalid-feedback">
                                {{ 'launcher.requiredField' | translate }}
                            </div>
                            }
                        </div>

                        <div class="col-auto mb-3">
                            <label for="experimentalCodeOfficialRegistration" class="form-label">{{
                                'launcher.experimentalRegistration' | translate }}</label>
                            <input id="experimentalCodeOfficialRegistration" type="text" class="form-control"
                                formControlName="experimentalCodeOfficialRegistration" placeholder="" />
                        </div>

                        <!-- cycleCodeOfficialRegistration -->
                        <div class="col-auto mb-3">
                            <label for="cycleCodeOfficialRegistration" class="form-label">{{ 'launcher.cycleOfficial' |
                                translate }}</label>
                            <input id="cycleCodeOfficialRegistration" type="text" class="form-control"
                                formControlName="cycleCodeOfficialRegistration" placeholder="" />
                        </div>
                    </div>
                </div>

                <div class="separator mt-5"></div>
                <h2><label class="form-label textformat">{{
                        'launcher.listProductOrSubject' | translate }}</label></h2>

                <div class="row mt-3">
                    @let controlIdProd = validateLaunchForm.get('idProductOrSubject');
                    <div class="col-auto mb-3">
                        <label for="idProductOrSubject" class="form-label text-nowrap">{{ 'launcher.idProductOrSubject'
                            | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <input id="idProductOrSubject" type="text" class="form-control"
                            formControlName="idProductOrSubject"
                            [class.is-invalid]="controlIdProd?.touched && controlIdProd?.invalid"
                            [class.is-valid]="controlIdProd?.valid && controlIdProd?.touched" />
                        @if (controlIdProd?.touched && controlIdProd?.invalid) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    <div class="col-auto mb-3">
                        <fieldset disabled>
                            <label for="academicField" class="form-label text-nowrap">{{ 'launcher.academic' | translate
                                }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="academicField" type="text" class="form-control" [value]="'N - Normal'" readonly>
                        </fieldset>
                    </div>

                    <div class="col-auto mb-3">
                        <label for="numberTimesProductoOrSubjectRegistered" class="form-label text-nowrap">{{
                            'launcher.numberTimesProductoOrSubjectRegistered' |
                            translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <input id="numberTimesProductoOrSubjectRegistered" type="text" class="form-control"
                            formControlName="numberTimesProductoOrSubjectRegistered"
                            [class.is-invalid]="validateLaunchForm.get('numberTimesProductoOrSubjectRegistered')?.touched &&
                                                             validateLaunchForm.get('numberTimesProductoOrSubjectRegistered')?.invalid"
                            [class.is-valid]="validateLaunchForm.get('numberTimesProductoOrSubjectRegistered')?.valid && (validateLaunchForm.get('numberTimesProductoOrSubjectRegistered')?.touched)" />
                        @if (validateLaunchForm.get('numberTimesProductoOrSubjectRegistered')?.touched &&
                        validateLaunchForm.get('numberTimesProductoOrSubjectRegistered')?.invalid )
                        {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    <div class="col-auto mb-3">
                        <label for="numberCreditsForProductOrSubject" class="form-label text-nowrap">{{
                            'launcher.numberCreditsForProductOrSubject' |
                            translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <input id="numberCreditsForProductOrSubject" type="text" class="form-control"
                            formControlName="numberCreditsForProductOrSubject"
                            [class.is-invalid]="validateLaunchForm.get('numberCreditsForProductOrSubject')?.touched &&
                                                             validateLaunchForm.get('numberCreditsForProductOrSubject')?.invalid"
                            [class.is-valid]="validateLaunchForm.get('numberCreditsForProductOrSubject')?.valid && (validateLaunchForm.get('numberCreditsForProductOrSubject')?.touched)" />
                        @if (validateLaunchForm.get('numberCreditsForProductOrSubject')?.touched &&
                        validateLaunchForm.get('numberCreditsForProductOrSubject')?.invalid )
                        {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    @let controlLear = validateLaunchForm.get('chargeLearningResources');
                    <div class="col-auto  mb-3">
                        <label for="chargeLearningResources" class="form-label">{{ 'launcher.chargeLearning' | translate
                            }}
                            <span class="text-danger">*</span>
                        </label>
                        <select id="chargeLearningResources" class="form-select"
                            formControlName="chargeLearningResources"
                            [class.is-invalid]="controlLear?.invalid && (controlLear?.touched || formSubmit)"
                            [class.is-valid]="controlLear?.valid && (controlLear?.touched || formSubmit)">
                            @for (learning of paramLauncherResponseDto.paramLauncherDto.chargeLearningResources; track
                            $index) {
                            <option [value]="learning">{{ learning }} - {{ learningKey[learning] | translate }}</option>
                            }
                        </select>
                        @if (controlLear?.invalid && (controlLear?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>

                    <div class="col-auto  mb-3">
                        <fieldset disabled>
                            <label for="typeLearningValue" class="form-label">{{ 'launcher.typeLearning' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <input id="typeLearningValue" type="text" class="form-control"
                                [value]="'launcher.typeLearningValue' | translate" readonly>
                        </fieldset>
                    </div>

                    @let controlStatus = validateLaunchForm.get('statusProductOrSubject');
                    <div class="col-auto  mb-3">
                        <label for="statusProductOrSubject" class="form-label">{{ 'launcher.status' | translate }}
                            <span class="text-danger">*</span>
                        </label>
                        <select id="statusProductOrSubject" class="form-select" formControlName="statusProductOrSubject"
                            [class.is-invalid]="controlStatus?.invalid && (controlStatus?.touched || formSubmit)"
                            [class.is-valid]="controlStatus?.valid && (controlStatus?.touched || formSubmit)">
                            @for (status of paramLauncherResponseDto.paramLauncherDto.statusProductOrSubject; track
                            $index) {
                            <option [value]="status"> {{ status }} - {{ statusLabelKey[status] | translate }}</option>
                            }
                        </select>
                        @if (controlStatus?.invalid && (controlStatus?.touched || formSubmit)) {
                        <div class="invalid-feedback">
                            {{ 'launcher.requiredField' | translate }}
                        </div>
                        }
                    </div>
                </div>

                <button type="submit" class="btn custombutton mt-3">{{ 'launcher.send' | translate }}</button>
            </form>
        </div>

        <!-- Spinner modal para el spinner -->
        <app-spinner-modal [potential]="true"></app-spinner-modal>

        <!-- Datos del potencial-->
        @if(this.enrollmentFeeDiscountsResponse.listCurrencyTraduction.length > 0 ) {
        <div class="separator mt-5"></div>
        <div class="card mt-5">
            <div class="card-header">
                {{ 'launcher.response-calc' | translate }}
            </div>
            <div class="accordion mt-3" id="accordionExample">

                <!-- Código Moneda -->
                <div class="accordion-item">
                    <h2 class="accordion-header custombutton">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            {{ 'launcher.currency-code' | translate }}
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <div class="d-flex align-items-center">
                                <span class="me-2 fw-bold text-muted">{{ 'launcher.currency' | translate }}:</span>
                                <span class="badge bg-primary fs-6">{{ enrollmentFeeDiscountsResponse.currencyCode
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Traducción Moneda -->
                <div class="accordion-item">
                    <h2 class="accordion-header custombutton">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            {{ 'launcher.traduction-currency' | translate }}
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <ul class="list-group">
                                @for (traduction of enrollmentFeeDiscountsResponse.listCurrencyTraduction; track $index)
                                {
                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    <span class="fw-bold text-muted">
                                        {{ traduction.isoLanguageCode == 'es' ? 'Español' : traduction.isoLanguageCode
                                        == 'ca' ?
                                        'Catalán' : 'Inglés' }}
                                    </span>
                                    <span class="badge bg-primary fs-6">{{ traduction.description }}</span>
                                </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Programas o Asignaturas -->
                <div class="accordion-item">
                    <h2 class="accordion-header custombutton">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            {{ 'launcher.productOrSubject' | translate }}
                        </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div class="row justify-content-center">
                            @for (pr of enrollmentFeeDiscountsResponse.listProductsOrSubjectsOfRegistration; track
                            $index) {
                            <div class="col-auto">
                                <div class="card shadow-sm rounded-3 m-2 mb-5 w-100" style="width: 18rem;">

                                    <!-- Header -->
                                    <div class="card-header text-center bg-primary text-white">
                                        <h2 class="mb-0">
                                            <strong>{{ 'launcher.academicAndLearning' | translate }}</strong>
                                        </h2>
                                    </div>

                                    <!-- Body -->
                                    <div class="card-body">
                                        <ul class="list-group list-group-flush">

                                            <!-- Tasa Académica -->
                                            <li class="list-group-item py-2">
                                                <h6 class="fw-bold mb-2 text-primary">{{ 'launcher.taxAcademic' |
                                                    translate }}</h6>
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.priceForCredit' | translate }}:</span>
                                                    <span>
                                                        <strong>{{ pr.teachingPriceDataDto.pricePerCredit}} €</strong>
                                                    </span>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.priceNet' | translate }}:</span>
                                                    <span>
                                                        <strong>{{pr.teachingPriceDataDto.netPriceOfSubjectWithoutVat}} €</strong>
                                                    </span>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.vat' | translate }} ({{
                                                        pr.teachingPriceDataDto.vatType }}%):</span>
                                                    <span>
                                                        <strong>{{ pr.teachingPriceDataDto.vatAmount}} €</strong>
                                                    </span>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.totalWithVat' | translate }}:</span>
                                                    <span>
                                                        <strong>{{pr.teachingPriceDataDto.coursePriceWithVat}} €</strong>
                                                    </span>
                                                </div>
                                            </li>

                                            <!-- Tasa Recurso de Aprendizaje -->
                                            <li class="list-group-item py-2">
                                                <h6 class="fw-bold mb-2 text-primary">{{ 'launcher.learningResource' |
                                                    translate }}</h6>
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.priceForCredit' | translate }}:</span>
                                                    <span>
                                                        <strong>{{
                                                            pr.learningResourcesPriceData.pricePerCredit}} €</strong>
                                                    </span>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.priceNet' | translate }}:</span>
                                                    <span>
                                                        <strong>{{pr.learningResourcesPriceData.netPriceOfLearningResourcesWithoutVat}} €</strong>
                                                    </span>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.vat' | translate }} ({{
                                                        pr.learningResourcesPriceData.vatType }}%):</span>
                                                    <span>
                                                        <strong>{{ pr.learningResourcesPriceData.vatAmount}} €</strong>
                                                    </span>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.totalWithVat' | translate }}:</span>
                                                    <span><strong>{{pr.learningResourcesPriceData.learningResourcePriceWithVat}} €</strong>
                                                    </span>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.indicatorShipping' | translate }}:</span>
                                                    <span>
                                                        <strong>{{pr.learningResourcesPriceData.shippingChargeIndicator}}</strong>
                                                    </span>
                                                </div>
                                            </li>

                                            <!-- Total general -->
                                            <li class="list-group-item py-2 bg-light">
                                                <div class="d-flex justify-content-between">
                                                    <span><strong>{{ 'launcher.totalAcademicAndLearning' | translate
                                                            }}:</strong></span>
                                                    <span class="text-success fw-bold">{{ pr.totalPriceProductOrSubject
                                                        }} €</span>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>


                    </div>
                </div>

                <!-- Tasas Administrativas opcionales -->
                <div class="accordion-item">
                    <h2 class="accordion-header custombutton">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            {{ 'launcher.taxAdminOptional' | translate }}
                        </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div class="row justify-content-center">
                            @for (op of enrollmentFeeDiscountsResponse.listOptionalAdministrativeFee; track $index) {
                            <div class="col-auto">
                                <div class="card shadow-sm rounded-3 m-2 mb-5 w-100" style="width: 18rem;">

                                    <!-- Header -->
                                    <div class="card-header text-center bg-primary text-white">
                                        <h2 class="mb-0">
                                            <strong>{{ 'launcher.idTaxAdminOptional' | translate }}: </strong>
                                            <span class="fw-bold">{{ op.idFeeCodeOptional }}</span>
                                        </h2>
                                    </div>

                                    <!-- Body -->
                                    <div class="card-body">
                                        <ul class="list-group list-group-flush">

                                            <!-- Traducciones -->
                                            @for (tr of op.listOptionalAdministrativeFeetraduction; track $index) {
                                            <li class="list-group-item py-2">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <span class="text-muted small">{{ tr.isoLanguageCode == 'es'
                                                        ?'Español' :
                                                        tr.isoLanguageCode == 'ca' ? 'Catalán' : 'Inglés' }}</span>
                                                    <span class="fw-semibold">{{ tr.description }}</span>
                                                </div>
                                            </li>
                                            }
                                            <!-- Precios -->
                                            <li class="list-group-item py-2">
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.priceNet' | translate }}:</span>
                                                    <span><strong>{{ op.netPriceWithOutVat }} €</strong></span>
                                                </div>
                                            </li>
                                            <li class="list-group-item py-2">
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.vat' | translate }} ({{ op.vatType }}%):</span>
                                                    <span><strong>{{ op.vatAmount }} €</strong></span>
                                                </div>
                                            </li>
                                            <li class="list-group-item py-2">
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ 'launcher.totalWithVat' | translate }} :</span>
                                                    <span class="text-success fw-bold"><strong>{{ op.ratePriceWithVat
                                                            }} €</strong></span>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>

                    </div>
                </div>

                <!-- Descuentos actuales -->
                <div class="accordion-item">
                    <h2 class="accordion-header custombutton">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                            {{ 'launcher.discount' | translate }}
                        </button>
                    </h2>
                    <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">

                        <div class="row justify-content-center">
                            <div class="col-auto">
                                <div class="d-flex flex-wrap justify-content-center">
                                    @for (discount of enrollmentFeeDiscountsResponse.listCurrentDiscount; track $index)
                                    {
                                    <div class="card shadow-sm rounded-3 m-2 mb-5">

                                        <div class="card-header text-center bg-primary text-white">
                                            <h2 class="mb-0">
                                                <strong>{{ 'launcher.idDiscount' | translate }}:</strong> <span
                                                    class="fw-bold">{{
                                                    discount.idDiscountCode }}</span>
                                            </h2>
                                            <small class="badge bg-light text-dark"><strong>Orden</strong> {{
                                                discount.orderNumber }}</small>
                                        </div>

                                        <div class="card-body">

                                            <!-- Porcentaje o importe fijo -->
                                            <ul class="list-group list-group-flush list-unstyled">
                                                @if (discount.discountPercentage != null) {
                                                <li>
                                                    <span>
                                                        <strong>{{ 'launcher.disc' | translate }}: </strong> <span
                                                            class="text-success">{{
                                                            discount.discountPercentage }}%</span>
                                                    </span>
                                                </li>

                                                }@if(discount.discountFixedAmount !== null) {
                                                <li>
                                                    <span>
                                                        <strong>{{ 'launcher.importFixe' | translate }}: </strong><span
                                                            class="text-info">{{
                                                            discount.discountFixedAmount }} €</span>
                                                    </span>
                                                </li>
                                                }
                                            </ul>

                                            <!-- Indicadores -->
                                            <div class="d-flex flex-wrap gap-2 mb-3">
                                                <!-- Indicadores -->
                                                <ul class="list-group list-group-flush list-unstyled">
                                                    <li>
                                                        <strong>{{ 'launcher.cumulative' | translate }}:</strong> {{
                                                        discount.accumulativeDiscountIndicator == 'S' ? 'Sí':'No' }}
                                                    </li>
                                                    <li>
                                                        <strong>{{ 'launcher.visibleStudent' | translate }}:</strong> {{
                                                        discount.studentVisibleDiscountIndicator == 'S' ? 'Sí':'No' }}
                                                    </li>
                                                    <li>
                                                        <strong>{{ 'launcher.visibleManager' | translate }}:</strong> {{
                                                        discount.managerVisibleDiscountIndicator == 'S' ? 'Sí': 'No' }}
                                                    </li>
                                                    <li>
                                                        <strong>{{ 'launcher.docAssociate' | translate }}:</strong> {{
                                                        discount.documentationAssociatedDiscountIndicator == 'S' ? 'Sí':
                                                        'No' }}
                                                    </li>
                                                    <li>
                                                        <strong>{{ 'launcher.validationTercer' | translate }}:</strong>
                                                        {{
                                                        discount.validDiscountIndicatorTercer == 'S' ? 'Sí': 'No' }}
                                                    </li>
                                                    <li>
                                                        <strong>{{ 'launcher.validationManual' | translate }}:</strong>
                                                        {{ discount.manualValidation
                                                        ==
                                                        'S' ? 'Sí': 'No' }}
                                                    </li>
                                                </ul>
                                            </div>
                                            <!-- Secciones de traducción -->
                                            <ng-container *ngFor="let section of [
            { title: 'Datos sensibles', list: discount.listOfSensitiveDataTraduction },
            { title: 'Descripción', list: discount.listDiscountDescription },
            { title: 'Info descuento', list: discount.listDiscountInformationText },
            { title: 'Textos doc. asociada', list: discount.listInformativeTextAssociateDocumentation }
          ]">
                                                <div *ngIf="section.list?.length">
                                                    <h6 class="mt-3">
                                                        <strong>{{ section.title }}</strong>
                                                    </h6>
                                                    <ul class="list-group list-group-flush">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center py-1"
                                                            *ngFor="let dto of section.list">
                                                            <span class="text-muted">{{ dto.isoLanguageCode == 'es' ?
                                                                'Español' :
                                                                dto.isoLanguageCode == 'ca' ? 'Catalán' : 'Inglés'
                                                                }}</span>
                                                            <span>{{ dto.description }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>

                                    }
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </div>

        }